import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";
import {IJpInfoData, infoType} from "../../interface/IFooter";
import infoTW from "./InfoTW";
import infoJP from "./InfoJP";
import infoRU from "./InfoRU";
import infoCS from "./InfoCS";
import infoNAEU from "./InfoNAEU";

export default class Info{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        const infoEl = makeEl('div', _parent, {class: 'footer-info'})
        const csInfoType : infoType = this.ds.config.csInfoType;

        if((this.ds.country === 'JP') && (this.ds.service !== 'plaync')){
            new infoJP(infoEl);
            return;
        }
        if((this.ds.country === 'TW') && (this.ds.service !== 'plaync')){
            new infoTW(infoEl);
            return;
        }
        if(this.ds.service === 'lineage2mru'){
            new infoRU(infoEl);
            return;
        }
        if(this.ds.service === 'lineage2mnaeu'){
            new infoNAEU(infoEl);
            return;
        }
        new infoCS(infoEl, csInfoType);
    }
}